import React, { FC } from 'react';
import { createStore, Provider } from 'jotai';

export const jotaiStore = createStore();

export const JotaiStoreProvider: FC = ({ children }) => {
  return <Provider store={jotaiStore}>{children}</Provider>;
};
